module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Regular_1_b51ad6cd.4b9d8922.woff2";